export default __webpack_public_path__ + "static/media/SpheroEdu.fed7bb0b.webp";